// src/components/common/Template_Layouts/configs/themeConfig.js
const themeConfig = {
  templateName: 'Kit19',
  settingsCookieName: 'kit19-settings',
  mode: 'light', // 'light', 'dark', 'system'
  skin: 'default', // 'default', 'bordered'
  contentWidth: 'compact', // 'compact', 'wide'
  layout: 'vertical', // 'vertical', 'horizontal'
  navbar: {
    type: 'fixed', // 'fixed', 'static', 'hidden'
    contentWidth: 'compact' // 'compact', 'wide'
  },
  footer: {
    type: 'static', // 'fixed', 'static', 'hidden'
    contentWidth: 'compact' // 'compact', 'wide'
  }
};

export default themeConfig;
